// import React, { useEffect, useState } from "react";
// import { ZoomMtg } from "@zoom/meetingsdk";
// import { apiGet } from "../../util/axiosUtil";
// import API_URL from "../../config/apiConfig";
// import "../../App.css";

// const Zoom = () => {
//   const sdkKey = "ImcpQL0WSzmkmeQOtnzFqA"; // Replace with your SDK App Key
//   const meetingNumber = "9819812121"; // Replace with your meeting number
//   const role = 0; // 1 for host, 0 for participant
//   const userName = "React User";
//   const userEmail = "your-email@example.com"; // Required for Webinar
//   const password = "3535"; // Password should be a string
//   const leaveUrl = process.env.REACT_APP_ZOOM_LEAVE_URL;
//   const authEndpoint = `${API_URL}/api/zoom/generate-signature`; // Replace with your backend URL

//   // State to hold the signature
//   const [signature, setSignature] = useState("");
//   const [error, setError] = React.useState("");

//   const getSignature = async () => {
//     try {
//       const response = await apiGet(
//         `${authEndpoint}?meetingNumber=${meetingNumber}&role=${role}`
//       );

//       if (response.status === 200) {
//         startMeeting(response.data.data);
//         setError(null);
//       } else {
//         setError("Failed to accept refund. Please try again.");
//       }
//     } catch (err) {
//       setError("An error occurred while processing the refund.");
//     }
//   };

//   // Start the meeting with the signature
//   const startMeeting = (signature) => {
//     ZoomMtg.init({
//       leaveUrl: leaveUrl, // URL to redirect when the meeting ends
//       isSupportAV: true,
//       success: () => {
//         ZoomMtg.join({
//           meetingNumber,
//           userName,
//           signature,
//           sdkKey,
//           userEmail,
//           passWord: password,
//           success: () => {
//             console.log("Join meeting success");
//           },
//           error: (err) => {
//             console.error("Join meeting error", err);
//           },
//         });
//       },
//       error: (err) => {
//         setError("Error joining meeting: " + error.message);
//         console.error("Init error", err);
//       },
//     });
//   };

//   // Use useEffect to fetch the signature on component mount
//   useEffect(() => {
//     if (signature) {
//       console.log("Start Meeting");
//       startMeeting(signature);
//     }
//   }, [signature]);

//   return (
//     <div>
//       <h1>Zoom Integration</h1>
//       <button className="bg-white" onClick={getSignature}>
//         Join Meeting
//       </button>
//       <div id="zoomContainer"></div>
//       {error && (
//         <h1 className="text-red-600 text-sm font-semibold justify-self-center">
//           {error}
//         </h1>
//       )}
//     </div>
//   );
// };

// export default Zoom;

//------------------------------------------------------------
// New Best UI working

// import "../../App.css";
// import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
// import React from "react";
// import { apiGet } from "../../util/axiosUtil";
// import API_URL from "../../config/apiConfig";

// function Zoom() {
//   const clientRef = React.useRef(null);
//   const joinedRef = React.useRef(false);
//   const [error, setError] = React.useState("");
//   const [loading, setLoading] = React.useState(false);

//   const authEndpoint = `${API_URL}/api/zooms/get-zoom-token`;

//   React.useEffect(() => {
//     if (!clientRef.current) {
//       clientRef.current = ZoomMtgEmbedded.createClient();
//     }
//   }, []);

//   const getSignature = async () => {
//     if (joinedRef.current) {
//       setError("You are already in a meeting.");
//       return;
//     }

//     setError("");
//     setLoading(true);

//     try {
//       const response = await apiGet(authEndpoint);
//       if (response.status === 200) {
//         const base64Signature = response.data;
//         const decodedSignatureJson = atob(base64Signature);
//         const parsedDecodedSignature = JSON.parse(decodedSignatureJson);
//         console.log("Signature response:", response.data);
//         await startMeeting(base64Signature, parsedDecodedSignature);
//       } else {
//         setError("Failed to get signature. Please try again.");
//       }
//     } catch (err) {
//       setError("An error occurred while fetching the Zoom signature.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   async function startMeeting(base64Signature, decodedSignature) {
//     const meetingSDKElement = document.getElementById("meetingSDKElement");

//     try {
//       if (typeof ZoomHelper !== "undefined") {
//         const uuid = window.ZoomHelper.getUUID();
//         console.log("Device UUID:", uuid);
//         // eslint-disable-next-line no-undef
//         ZoomHelper.joinMeeting(base64Signature);
//         joinedRef.current = true;
//         return;
//       } else if (window?.chrome?.webview?.postMessage) {
//         window.chrome.webview.postMessage({ jwt: base64Signature });
//         joinedRef.current = true;
//         return;
//       } else if (
//         typeof webkit !== "undefined" &&
//         // eslint-disable-next-line no-undef
//         webkit?.messageHandlers?.callback?.postMessage
//       ) {
//         // eslint-disable-next-line no-undef
//         webkit.messageHandlers.callback.postMessage(
//           JSON.stringify({ jwt: base64Signature })
//         );
//         joinedRef.current = true;
//         return;
//       }

//       const client = clientRef.current;

//       await client.init({
//         zoomAppRoot: meetingSDKElement,
//         language: "en-US",
//         patchJsMedia: true,
//         leaveOnPageUnload: true,
//       });

//       await client.join({
//         signature: decodedSignature.web.signature,
//         sdkKey: decodedSignature.web.sdkKey,
//         meetingNumber: decodedSignature.web.meetingNumber,
//         password: decodedSignature.web.passWord,
//         userName: decodedSignature.web.userName,
//         userEmail: decodedSignature.web.userEmail,
//         ...(decodedSignature.zakToken && {
//           zak: decodedSignature.web.zakToken,
//         }),
//       });

//       joinedRef.current = true;
//       console.log("Joined successfully");
//     } catch (error) {
//       setError("Error joining meeting: " + error.message);
//       console.error(error);
//     }
//   }

//   return (
//     <div className="App">
//       <main>
//         <h1>Zoom Meeting SDK Sample React</h1>
//         <div id="meetingSDKElement" />
//         <button
//           className="bg-slate-400 hover:bg-red-700 px-4 py-2 text-white rounded"
//           onClick={getSignature}
//           disabled={loading || joinedRef.current}
//         >
//           {loading
//             ? "Joining..."
//             : joinedRef.current
//             ? "Joined"
//             : "Join Meeting"}
//         </button>
//       </main>
//       {error && (
//         <h1 className="text-red-600 text-sm font-semibold justify-self-center">
//           {error}
//         </h1>
//       )}
//     </div>
//   );
// }

// export default Zoom;

//------------------------------------------------------------------------

// import "../../App.css";
// import { ZoomMtg } from "@zoom/meetingsdk";
// import { apiGet } from "../../util/axiosUtil";
// import React, { useEffect } from "react";
// import API_URL from "../../config/apiConfig";
// import { useLocation } from "react-router-dom";

// const Zoom = () => {
//   const location = useLocation();
//   const meetingData = location.state?.meetingData || {};
//   const { meetingId, sdkKey, meetingPassword } = meetingData;
//   const meetingNumber = meetingId;
//   const role = 0; // 1 for host, 0 for participant
//   const userName = "React User";
//   const userEmail = "your-email@example.com"; // Required for Webinar
//   const passWord = meetingPassword; // Password should be a string
//   const leaveUrl = `${window.location.origin}/schedule`;
//   const authEndpoint = `${API_URL}/api/zoom/generate-signature`; // Replace with your backend URL
//   const [error, setError] = React.useState("");

//   useEffect(() => {
//     // Clean up the meeting when component unmounts
//     return () => {
//       try {
//         ZoomMtg.leaveMeeting({});
//       } catch (e) {
//         console.log("No active meeting to leave");
//       }

//       const zoomRoot = document.getElementById("zmmtg-root");
//       if (zoomRoot) {
//         zoomRoot.style.display = "none";
//       }
//     };
//   }, []);

//   const getSignature = async () => {
//     try {
//       const response = await apiGet(
//         `${authEndpoint}?meetingNumber=${meetingNumber}&role=${role}`
//       );

//       if (response.status === 200) {
//         startMeeting(response.data.data);
//         setError(null);
//       } else {
//         setError("Failed to accept refund. Please try again.");
//       }
//     } catch (err) {
//       setError("An error occurred while processing the refund.");
//     }
//   };

//   function startMeeting(signature) {
//     ZoomMtg.preLoadWasm();
//     ZoomMtg.prepareWebSDK();
//     ZoomMtg.i18n.load("en-US");
//     document.getElementById("zmmtg-root").style.display = "block";

//     ZoomMtg.init({
//       leaveUrl: leaveUrl,
//       patchJsMedia: true,
//       disableCORP: true,
//       leaveOnPageUnload: true,
//       success: (success) => {
//         console.log(success);
//         ZoomMtg.join({
//           signature: signature,
//           sdkKey: sdkKey,
//           meetingNumber: meetingNumber,
//           passWord: passWord,
//           userName: userName,
//           userEmail: userEmail,
//           //   tk: registrantToken,
//           //   zak: zakToken,
//           success: (success) => {
//             console.log(success);
//           },
//           error: (error) => {
//             console.log(error);
//           },
//         });
//       },
//       error: (error) => {
//         console.log(error);
//       },
//     });
//   }

//   return (
//     <div className="App">
//       <main>
//         <h1>Zoom Meeting SDK Sample React</h1>
//         <button onClick={getSignature}>Join Meeting</button>
//       </main>
//     </div>
//   );
// };

// export default Zoom;
// ------------------------------------------------------
// import { useContext } from "react";
// import { ConfigContext } from "../../util/ConfigContext";
// import "../../App.css";
// import { ZoomMtg } from "@zoom/meetingsdk";
// import { apiGet } from "../../util/axiosUtil";
// import React, { useEffect } from "react";
// import API_URL from "../../config/apiConfig";
// import { useLocation, useNavigate } from "react-router-dom";

// const Zoom = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { rawJwt, sessionToken } = useContext(ConfigContext);
//   const meetingNumber = location.state?.meetingData || {};
//   console.log("Meeting Number: ", meetingNumber);
//   const leaveUrl = `${window.location.origin}/schedule`;
//   const authEndpoint = `${API_URL}/api/zooms/get-zoom-token/${meetingNumber}`; // Replace with your backend URL
//   const socketEndPoint = `${API_URL}/ws?token=${rawJwt}&sessionToken=${sessionToken}`;
//   const [error, setError] = React.useState("");

//   useEffect(() => {
//     // ZoomMtg.setZoomJSLib("https://source.zoom.us/3.11.2/lib", "/av");
//     ZoomMtg.preLoadWasm();
//     ZoomMtg.prepareWebSDK();
//     document.getElementById("zmmtg-root").style.display = "none";
//     return () => {
//       try {
//         ZoomMtg.leaveMeeting({});
//         const zoomRoot = document.getElementById("zmmtg-root");
//         if (zoomRoot) {
//           zoomRoot.remove();
//         }
//       } catch (e) {
//         console.log("No active meeting to leave");
//       }
//     };
//   }, []);

//   const getSignature = async () => {
//     try {
//       const response = await apiGet(authEndpoint);

//       if (response.status === 200) {
//         console.log("Signature response: ", response.data);
//         const jsonString = atob(response.data);

//         // Parse JSON string into JavaScript object
//         const jsonObject = JSON.parse(jsonString);
//         console.log("JSON OBJECT: ", jsonObject);

//         jsonObject && startMeeting(jsonObject, response.data.data);
//         setError(null);
//       } else {
//         setError("Failed to join meeting. Please try again.");
//       }
//     } catch (err) {
//       setError("An error occurred while joining the meeting.");
//     }
//   };

//   function startMeeting(jsonData, encodedString) {
//     document.getElementById("zmmtg-root").style.display = "block";

//     try {
//       if (typeof ZoomHelper !== "undefined") {
//         // eslint-disable-next-line no-undef
//         ZoomHelper.joinMeeting(encodedString);
//         return navigate("/");
//       } else if (window?.chrome?.webview?.postMessage) {
//         // eslint-disable-next-line no-undef
//         window.chrome.webview.postMessage(encodedString);
//         return navigate("/");
//         // eslint-disable-next-line no-undef
//       } else if (
//         typeof webkit !== "undefined" &&
//         // eslint-disable-next-line no-undef
//         webkit?.messageHandlers?.callback?.postMessage
//       ) {
//         // eslint-disable-next-line no-undef
//         webkit.messageHandlers.callback.postMessage(encodedString);
//         return navigate("/");
//       }
//     } catch (error) {
//       console.error("Error in startMeeting: ", error);
//       setError("Error starting meeting.");
//       return;
//     }

//     ZoomMtg.init({
//       leaveUrl: leaveUrl,
//       disableCORP: true, // Ensure it does not conflict with COEP
//       patchJsMedia: true,
//       leaveOnPageUnload: true,
//       success: () => {
//         ZoomMtg.join({
//           signature: jsonData.web.signature,
//           sdkKey: jsonData.web.sdkKey,
//           meetingNumber: jsonData.web.meetingNumber,
//           passWord: jsonData.web.passWord,
//           userName: jsonData.web.userName,
//           userEmail: jsonData.web.userEmail,
//           success: () => {
//             console.log("Joined Meeting Successfully");
//           },
//           error: (error) => {
//             console.error("Join Meeting Error: ", error);
//             setError("Failed to join meeting.");
//           },
//         });
//       },
//       error: (error) => {
//         console.error("Zoom Init Error: ", error);
//         setError("Error initializing Zoom SDK.");
//       },
//     });
//   }

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 to-gray-700 text-white">
//       <div className="bg-gray-800 p-8 rounded-2xl shadow-xl text-center w-96">
//         <h1 className="text-2xl font-bold mb-6">Zoom Meeting SDK</h1>
//         <button
//           onClick={getSignature}
//           className="w-full py-3 bg-blue-600 hover:bg-blue-500 focus:ring-4 focus:ring-blue-300 transition-all rounded-xl text-lg font-medium"
//         >
//           Join Meeting
//         </button>
//         {error && <p className="mt-4 text-red-400 animate-pulse">{error}</p>}
//       </div>
//     </div>
//   );
// };

// export default Zoom;
// import { useContext, useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { ZoomMtg } from "@zoom/meetingsdk";
// import { ConfigContext } from "../../util/ConfigContext";
// import { apiGet } from "../../util/axiosUtil";
// import { toast } from "react-toastify";
// import API_URL from "../../config/apiConfig";
// import { invalidateCookie } from "../../util/JwtUtil";
// import "../../App.css";

// const Zoom = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { rawJwt } = useContext(ConfigContext);
//   const meetingNumber = location.state?.meetingData;
//   const [error, setError] = useState(null);
//   const socketRef = useRef(null);
//   const reconnectAttemptsRef = useRef(0);

//   const leaveUrl = `${window.location.origin}/schedule`;
//   const authEndpoint = `${API_URL}/api/zooms/get-zoom-token/${meetingNumber}`;

//   const logout = () => {
//     closeSocket();
//     invalidateCookie("token");
//     navigate("/");
//   };

//   useEffect(() => {
//     return () => {
//       try {
//         ZoomMtg.leaveMeeting({});
//       } catch (e) {
//         console.log("Cleanup: No active meeting");
//       }
//       closeSocket();
//     };
//   }, []);

//   const connectSocket = (websocketUrl) => {
//     if (socketRef.current) return;

//     const connect = () => {
//       const ws = new WebSocket(websocketUrl);

//       ws.onopen = () => {
//         console.log("WebSocket connected");
//         reconnectAttemptsRef.current = 0;
//       };

//       ws.onclose = (event) => {
//         console.warn("WebSocket disconnected", event.code, event.reason);
//         socketRef.current = null;

//         if (
//           event.code === 4001 &&
//           event.reason === "Another session replaced this one"
//         ) {
//           console.warn("Logged out due to another session. Not reconnecting.");
//           toast.warn(
//             "You've been logged out: another session replaced yours.",
//             {
//               position: "top-center",
//               autoClose: 5000,
//               pauseOnHover: true,
//               draggable: true,
//             }
//           );

//           // Delay logout so toast has time to render
//           setTimeout(() => {
//             logout();
//           }, 100); // 100–500ms is enough
//           return;
//         }

//         if (reconnectAttemptsRef.current < 5) {
//           reconnectAttemptsRef.current++;
//           setTimeout(connect, 1000 * reconnectAttemptsRef.current);
//         }
//       };

//       ws.onerror = (err) => {
//         console.error("WebSocket error:", err);
//         ws.close();
//       };

//       ws.onmessage = (msg) => {
//         // Handle messages here if needed
//         // Example: ping/pong or event-based messages
//       };

//       socketRef.current = ws;
//     };

//     connect();
//   };

//   const closeSocket = () => {
//     if (socketRef.current) {
//       socketRef.current.close();
//       socketRef.current = null;
//     }
//   };

//   const getSignature = async () => {
//     try {
//       const response = await apiGet(authEndpoint);

//       if (response.status === 200) {
//         const jsonObject = JSON.parse(atob(response.data));
//         startMeeting(jsonObject, response.data);
//         setError(null);
//       } else {
//         setError("Failed to join meeting. Please try again.");
//       }
//     } catch (err) {
//       console.error("Signature fetch failed:", err);
//       setError("An error occurred while joining the meeting.");
//     }
//   };

//   const startMeeting = (jsonData, encodedString) => {
//     // document.getElementById("zmmtg-root").style.display = "block";
//     let websocketUrl =
//       "ws://" + window.location.hostname + ":8008/ws?token=" + rawJwt;
//     try {
//       if (typeof ZoomHelper !== "undefined") {
//         // eslint-disable-next-line no-undef
//         ZoomHelper.joinMeeting(encodedString, websocketUrl);
//         return navigate("/schedule");
//       }

//       if (window?.chrome?.webview?.postMessage) {
//         window.chrome.webview.postMessage(encodedString, websocketUrl);
//         return navigate("/schedule");
//       }

//       // eslint-disable-next-line no-undef
//       if (
//         typeof webkit !== "undefined" &&
//         // eslint-disable-next-line no-undef
//         webkit?.messageHandlers?.callback?.postMessage
//       ) {
//         const data = {
//           jwt: jsonData.ios.signature,
//           meetingNumber: jsonData.ios.meetingNumber,
//           meetingPassword: jsonData.ios.passWord,
//         };
//         console.log("Sending data to webview:", data);
//         // eslint-disable-next-line no-undef
//         webkit.messageHandlers.callback.postMessage(JSON.stringify(data));
//         return navigate("/schedule");
//       }
//     } catch (error) {
//       console.error("Error in native join:", error);
//       setError("Error starting meeting.");
//       return;
//     }

//     ZoomMtg.init({
//       leaveUrl,
//       disableCORP: true,
//       patchJsMedia: true,
//       leaveOnPageUnload: true,
//       success: () => {
//         ZoomMtg.preLoadWasm();
//         ZoomMtg.prepareWebSDK();
//         ZoomMtg.join({
//           signature: jsonData.web.signature,
//           sdkKey: jsonData.web.sdkKey,
//           meetingNumber: jsonData.web.meetingNumber,
//           passWord: jsonData.web.passWord,
//           userName: jsonData.web.userName,
//           userEmail: jsonData.web.userEmail,
//           success: () => {
//             console.log("Joined Meeting Successfully");
//             connectSocket(websocketUrl);
//           },
//           error: (err) => {
//             console.error("Join Meeting Error:", err);
//             setError("Failed to join meeting.");
//           },
//         });
//       },
//       error: (err) => {
//         console.error("Zoom Init Error:", err);
//         setError("Error initializing Zoom SDK.");
//       },
//     });
//   };

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 to-gray-700 text-white">
//       <div className="bg-gray-800 p-8 rounded-2xl shadow-xl text-center w-96">
//         <h1 className="text-2xl font-bold mb-6">Zoom Meeting SDK</h1>
//         <button
//           onClick={getSignature}
//           className="w-full py-3 bg-blue-600 hover:bg-blue-500 focus:ring-4 focus:ring-blue-300 transition-all rounded-xl text-lg font-medium"
//         >
//           Join Meeting
//         </button>
//         {error && <p className="mt-4 text-red-400 animate-pulse">{error}</p>}
//       </div>
//     </div>
//   );
// };

// export default Zoom;

import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ZoomMtg } from "@zoom/meetingsdk";
import { ConfigContext } from "../../util/ConfigContext";
import { apiGet } from "../../util/axiosUtil";
import { toast } from "react-toastify";
import API_URL from "../../config/apiConfig";
import { logoutWithRedirect } from "../../util/JwtUtil";
import "../../App.css";

const Zoom = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { jwt, rawJwt } = useContext(ConfigContext);
  const meetingNumber = location.state?.meetingData;

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const socketRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);

  const leaveUrl = `${window.location.origin}/schedule`;
  const authEndpoint = `${API_URL}/api/zooms/get-zoom-token/${meetingNumber}`;

  // const logout = () => {
  //   closeSocket();
  //   invalidateCookie("token");
  //   navigate("/");
  // };

  useEffect(() => {
    getSignature();

    return () => {
      try {
        ZoomMtg.leaveMeeting({});
      } catch (e) {}
      closeSocket();
    };
  }, []);

  useEffect(() => {
    window.onMeetingStatusChanged = function (status) {
      if (status === "ended" || status === "left") {
        navigate("/schedule");
      }
      // You could also set React state or show toast
    };

    return () => {
      delete window.onMeetingStatusChanged;
    };
  }, []);

  const getSignature = async () => {
    setLoading(true);
    try {
      const response = await apiGet(authEndpoint);
      if (response.status === 200) {
        const jsonObject = JSON.parse(atob(response.data));
        startMeeting(jsonObject, response.data);
        setError(null);
      } else {
        setError("Failed to join meeting. Please try again.");
      }
    } catch (err) {
      console.error("Signature fetch failed:", err);
      setError("An error occurred while joining the meeting.");
    } finally {
      setLoading(false);
    }
  };

  const startMeeting = (jsonData, encodedString) => {
    let websocketUrl =
      "ws://" + window.location.hostname + ":8008/ws?token=" + rawJwt;

    try {
      if (typeof ZoomHelper !== "undefined") {
        // eslint-disable-next-line no-undef
        ZoomHelper.joinMeeting(encodedString, websocketUrl);
        return;
      }

      if (window?.chrome?.webview?.postMessage) {
        window.chrome.webview.postMessage(encodedString, websocketUrl);
        return;
      }

      if (
        typeof webkit !== "undefined" &&
        // eslint-disable-next-line no-undef
        webkit?.messageHandlers?.callback?.postMessage
      ) {
        const data = {
          jwt: jsonData.ios.signature,
          meetingNumber: jsonData.ios.meetingNumber,
          meetingPassword: jsonData.ios.passWord,
        };
        // eslint-disable-next-line no-undef
        webkit.messageHandlers.callback.postMessage(JSON.stringify(data));
        return;
      }
    } catch (error) {
      console.error("Error in native join:", error);
      setError("Error starting meeting.");
      return;
    }

    ZoomMtg.init({
      leaveUrl,
      disableCORP: true,
      patchJsMedia: true,
      leaveOnPageUnload: true,
      success: () => {
        // document.getElementById("zmmtg-root").style.display = "block";
        ZoomMtg.preLoadWasm();
        ZoomMtg.prepareWebSDK();
        ZoomMtg.join({
          signature: jsonData.web.signature,
          sdkKey: jsonData.web.sdkKey,
          meetingNumber: jsonData.web.meetingNumber,
          passWord: jsonData.web.passWord,
          userName: jsonData.web.userName,
          userEmail: jsonData.web.userEmail,
          success: () => {
            connectSocket(websocketUrl);
          },
          error: (err) => {
            console.error("Join Meeting Error:", err);
            setError("Failed to join meeting.");
          },
        });
      },
      error: (err) => {
        console.error("Zoom Init Error:", err);
        setError("Error initializing Zoom SDK.");
      },
    });
  };

  const connectSocket = (websocketUrl) => {
    if (socketRef.current) return;

    const connect = () => {
      const ws = new WebSocket(websocketUrl);

      ws.onopen = () => {
        reconnectAttemptsRef.current = 0;
      };

      ws.onclose = (event) => {
        console.warn("WebSocket disconnected", event.code, event.reason);
        socketRef.current = null;

        if (event.code === 4001) {
          toast.warn(
            "You've been logged out: another session replaced yours.",
            {
              position: "top-center",
              autoClose: 5000,
              pauseOnHover: true,
              draggable: true,
            }
          );

          setTimeout(() => {
            logoutWithRedirect(useNavigate, jwt?.tenant);
          }, 100);
          return;
        }

        if (reconnectAttemptsRef.current < 5) {
          reconnectAttemptsRef.current++;
          setTimeout(connect, 1000 * reconnectAttemptsRef.current);
        }
      };

      ws.onerror = (err) => {
        console.error("WebSocket error:", err);
        ws.close();
      };

      ws.onmessage = (msg) => {
        // Handle messages if needed
      };

      socketRef.current = ws;
    };
    connect();
  };

  const closeSocket = () => {
    if (socketRef.current) {
      socketRef.current.close();
      socketRef.current = null;
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br relative">
      <div className="bg-gray-800/10 p-8 rounded-2xl shadow-xl text-center w-96">
        {error ? (
          <p className="text-red-400 animate-pulse">{error}</p>
        ) : (
          <h2 className="text-xl font-semibold">Preparing Zoom meeting...</h2>
        )}
      </div>

      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
          <h2 className="text-white text-xl font-semibold animate-pulse">
            Joining meeting...
          </h2>
        </div>
      )}
    </div>
  );
};

export default Zoom;

// ------xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-------
// Newest Version

// import { useContext, useEffect, useRef, useState } from "react";
// import { ConfigContext } from "../../util/ConfigContext";
// import "../../App.css";
// import { ZoomMtg } from "@zoom/meetingsdk";
// import { apiGet } from "../../util/axiosUtil";
// import API_URL from "../../config/apiConfig";
// import { useLocation, useNavigate } from "react-router-dom";
// import getJwtData, { invalidateCookie } from "../../util/JwtUtil";

// const Zoom = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { jwt, setJwt } = useContext(ConfigContext);
//   let jwtData = getJwtData(jwt);
//   console.log("JWT DATA", jwtData);
//   const meetingNumber = location.state?.meetingData || {};
//   const leaveUrl = `${window.location.origin}/schedule`;
//   const socketEndPoint = `${API_URL}/ws?token=${jwt}`;

//   const [error, setError] = useState("");
//   const socketRef = useRef(null);
//   const retryCount = useRef(0);
//   const maxRetries = 10;
//   const pingIntervalRef = useRef(null);
//   const isLoggedOutRef = useRef(false);

//   useEffect(() => {
//     // ZoomMtg.setZoomJSLib("https://source.zoom.us/3.11.2/lib", "/av");
//     ZoomMtg.preLoadWasm();
//     ZoomMtg.prepareWebSDK();
//     document.getElementById("zmmtg-root").style.display = "none";
//     connectWebSocket();

//     // return () => {
//     //   cleanup();
//     // };
//   }, []);

//   const connectWebSocket = () => {
//     if (isLoggedOutRef.current) {
//       console.warn("User logged out, stopping WebSocket reconnection.");
//       return;
//     }

//     if (retryCount.current >= maxRetries) {
//       console.warn("Max retries reached, closing page.");
//       cleanup();
//       window.close();
//       return;
//     }

//     socketRef.current = new WebSocket(socketEndPoint);

//     socketRef.current.onopen = () => {
//       console.log("WebSocket connected");
//       retryCount.current = 0;
//       startPingPong();
//     };

//     socketRef.current.onmessage = (event) => {
//       // console.log("Message received:", event.data);
//       if (event.data === "Logout") {
//         cleanup();
//         logout();
//       } else if (event.data === "Ping") {
//         socketRef.current.send("Pong");
//         // console.log("Pong sent");
//       }
//     };

//     socketRef.current.onerror = (error) => {
//       console.error("WebSocket error:", error);
//     };

//     socketRef.current.onclose = () => {
//       if (isLoggedOutRef.current) {
//         console.warn("WebSocket closed after logout, no retry.");
//         return;
//       }
//       console.warn("WebSocket closed, retrying...");
//       clearInterval(pingIntervalRef.current);
//       retryCount.current += 1;
//       setTimeout(connectWebSocket, 3000 * retryCount.current);
//     };
//   };

//   const startPingPong = () => {
//     pingIntervalRef.current = setInterval(() => {
//       if (socketRef.current?.readyState === WebSocket.OPEN) {
//         socketRef.current.send("Ping");
//         console.log("Ping sent");
//       } else {
//         clearInterval(pingIntervalRef.current);
//       }
//     }, 5000);
//   };

//   const cleanup = () => {
//     try {
//       ZoomMtg.leaveMeeting({});
//       if (socketRef.current) {
//         socketRef.current.close();
//       }
//       clearInterval(pingIntervalRef.current);
//       const zoomRoot = document.getElementById("zmmtg-root");
//       if (zoomRoot) {
//         zoomRoot.remove();
//       }
//     } catch (e) {
//       console.log("No active meeting to leave");
//     }
//   };

//   async function logout() {
//     isLoggedOutRef.current = true;
//     if (socketRef.current) {
//       socketRef.current.close();
//     }
//     clearInterval(pingIntervalRef.current);
//     setJwt(undefined);
//     invalidateCookie("token");
//     navigate("/");
//   }

//   const getSignature = async () => {
//     try {
//       const response = await apiGet(
//         `${API_URL}/api/zoom/generate-signature?meetingNumber=${meetingNumber}`
//       );

//       if (response.status === 200) {
//         const jsonString = atob(response.data.data);
//         const jsonObject = JSON.parse(jsonString);

//         console.log("Fixed Data: ", jsonObject);
//         jsonObject && startMeeting(jsonObject, response.data.data);
//         setError(null);
//       } else {
//         setError("Failed to join meeting. Please try again.");
//       }
//     } catch (err) {
//       setError("An error occurred while joining the meeting.");
//     }
//   };

//   function startMeeting(jsonData, encodedString) {
//     document.getElementById("zmmtg-root").style.display = "block";
//     try {
//       if (typeof ZoomHelper !== "undefined") {
//         // eslint-disable-next-line no-undef
//         ZoomHelper.joinMeeting(encodedString);
//         return navigate("/");
//       } else if (window?.chrome?.webview?.postMessage) {
//         // eslint-disable-next-line no-undef
//         window.chrome.webview.postMessage(encodedString);
//         return navigate("/");
//         // eslint-disable-next-line no-undef
//       } else if (
//         typeof webkit !== "undefined" &&
//         // eslint-disable-next-line no-undef
//         webkit?.messageHandlers?.callback?.postMessage
//       ) {
//         // eslint-disable-next-line no-undef
//         webkit.messageHandlers.callback.postMessage(encodedString);
//         return navigate("/");
//       }
//     } catch (error) {
//       console.error("Error in startMeeting: ", error);
//       setError("Error starting meeting.");
//       return;
//     }
//     ZoomMtg.init({
//       leaveUrl: leaveUrl,
//       leaveOnPageUnload: true,
//       success: () => {
//         ZoomMtg.join({
//           signature: jsonData.web.signature,
//           sdkKey: jsonData.web.sdkKey,
//           meetingNumber: jsonData.web.meetingNumber,
//           passWord: jsonData.web.passWord,
//           userName: jsonData.web.userName,
//           userEmail: jsonData.web.userEmail,
//           success: () => {
//             console.log("Joined Meeting Successfully");
//           },
//           error: (error) => {
//             console.error("Join Meeting Error: ", error);
//             setError("Failed to join meeting.");
//           },
//         });
//       },
//       error: (error) => {
//         console.error("Zoom Init Error: ", error);
//         setError("Error initializing Zoom SDK.");
//       },
//     });
//   }

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 to-gray-700 text-white">
//       <div className="bg-gray-800 p-8 rounded-2xl shadow-xl text-center w-96">
//         <h1 className="text-2xl font-bold mb-6">Zoom Meeting SDK</h1>
//         <button
//           onClick={getSignature}
//           className="w-full py-3 bg-blue-600 hover:bg-blue-500 focus:ring-4 focus:ring-blue-300 transition-all rounded-xl text-lg font-medium"
//         >
//           Join Meeting
//         </button>
//         {error && <p className="mt-4 text-red-400 animate-pulse">{error}</p>}
//       </div>
//     </div>
//   );
// };

// export default Zoom;

// --------------------------------------------------------
// import React, { useEffect, useState } from "react";
// import { ZoomMtg } from "@zoom/meetingsdk";
// import { apiGet } from "../../util/axiosUtil";
// import API_URL from "../../config/apiConfig";
// import { useLocation } from "react-router-dom";
// import "../../App.css";

// const Zoom = () => {
//   const location = useLocation();
//   const meetingData = location.state?.meetingData || {};
//   const { meetingId, sdkKey, meetingPassword } = meetingData;

//   const role = 0; // 1 for host, 0 for participant
//   const userName = "React User";
//   const userEmail = "your-email@example.com";
//   const leaveUrl = window.location.origin;
//   const authEndpoint = `${API_URL}/api/zoom/generate-signature`;
//   const [error, setError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     // Properly set up the SDK for version 3.11.2

//     // Clean up the meeting when component unmounts
//     return () => {
//       try {
//         ZoomMtg.leaveMeeting({});
//       } catch (e) {
//         console.log("No active meeting to leave");
//       }

//       const zoomRoot = document.getElementById("zmmtg-root");
//       // if (zoomRoot) {
//       //   zoomRoot.style.display = "none";
//       // }
//     };
//   }, []);

//   const getSignature = async () => {
//     setIsLoading(true);
//     setError("");

//     // Validate required parameters with detailed logging
//     console.log("Meeting data:", meetingData);

//     if (!meetingId) {
//       console.error("Missing meetingId");
//       setError("Meeting ID is required");
//       setIsLoading(false);
//       return;
//     }

//     if (!sdkKey) {
//       console.error("Missing sdkKey");
//       setError("SDK Key is required");
//       setIsLoading(false);
//       return;
//     }

//     if (!meetingPassword) {
//       console.error("Missing meetingPassword");
//       setError("Meeting password is required");
//       setIsLoading(false);
//       return;
//     }

//     try {
//       console.log("Requesting signature for meeting:", meetingId);
//       const response = await apiGet(
//         `${authEndpoint}?meetingNumber=${meetingId}&role=${role}`
//       );

//       console.log("Signature response:", response);

//       if (response && response.status === 200 && response.data.data) {
//         console.log("Signature obtained successfully");
//         startMeeting(response.data.data);
//       } else {
//         console.error("Signature response error:", response);
//         setError("Failed to get meeting signature from server");
//         setIsLoading(false);
//       }
//     } catch (err) {
//       console.error("Signature request failed:", err);
//       setError(
//         `Error: ${err.message || "Failed to connect to authentication server"}`
//       );
//       setIsLoading(false);
//     }
//   };

//   function startMeeting(signature) {
//     console.log("Starting meeting preparation...");

//     // Make sure the Zoom container is visible
//     const zoomRoot = document.getElementById("zmmtg-root");
//     if (zoomRoot) {
//       zoomRoot.style.display = "block";
//     }

//     // Try leaving any existing meeting first (safely with try/catch)
//     try {
//       ZoomMtg.leaveMeeting({});
//     } catch (e) {
//       console.log("No active meeting to leave");
//     }

//     console.log("Init parameters:", {
//       meetingId,
//       sdkKey,
//       meetingPassword,
//       userName,
//       userEmail,
//       signature,
//     });

//     ZoomMtg.setZoomJSLib("https://source.zoom.us/3.11.2/lib", "/av");
//     ZoomMtg.preLoadWasm();
//     ZoomMtg.prepareWebSDK();

//     // Load localization
//     ZoomMtg.i18n.load("en-US");
//     ZoomMtg.i18n.reload("en-US");

//     // Initialize Zoom with correct parameters
//     ZoomMtg.init({
//       debug: true,
//       leaveUrl: leaveUrl,
//       showMeetingHeader: true,
//       disableCORP: true,
//       disableInvite: false,
//       disableCallOut: false,
//       disableRecord: false,
//       disableJoinAudio: false,
//       audioPanelAlwaysOpen: true,
//       videoDrag: true,
//       isSupportAV: true,
//       isSupportChat: true,
//       isSupportQA: true,
//       isSupportCC: true,
//       screenShare: true,
//       rwcBackup: "",
//       videoDrag: true,
//       sharingMode: "both",
//       videoHeader: true,
//       isLockBottom: true,
//       isSupportNonverbal: true,
//       isShowJoiningErrorDialog: true,
//       disablePreview: false,
//       preloadWasm: true,
//       disableVoIP: false,
//       disableReport: false,
//       disableInvite: false,
//       meetingInfo: [
//         "topic",
//         "host",
//         "mn",
//         "pwd",
//         "telPwd",
//         "invite",
//         "participant",
//         "dc",
//         "enctype",
//       ],
//       success: () => {
//         console.log("SDK initialized successfully, joining meeting...");

//         // Join the meeting
//         ZoomMtg.join({
//           sdkKey: sdkKey,
//           signature: signature,
//           meetingNumber: meetingId,
//           passWord: meetingPassword,
//           userName: userName,
//           userEmail: userEmail,
//           success: () => {
//             console.log("Joined meeting successfully!");
//             setIsLoading(false);

//             // Force a rerender of the video
//             setTimeout(() => {
//               try {
//                 window.dispatchEvent(new Event("resize"));
//               } catch (e) {
//                 console.log("Error dispatching resize event:", e);
//               }
//             }, 1000);
//           },
//           error: (error) => {
//             console.error("Join meeting failed:", error);
//             setError(
//               `Failed to join: ${error.errorMessage || JSON.stringify(error)}`
//             );
//             setIsLoading(false);
//           },
//         });
//       },
//       error: (error) => {
//         console.error("SDK initialization failed:", error);
//         setError(
//           `SDK Init Error: ${error.errorMessage || JSON.stringify(error)}`
//         );
//         setIsLoading(false);
//       },
//     });
//   }

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {isLoading ? (
//         <div style={{ padding: "20px", textAlign: "center" }}>
//           <h2>Loading Zoom Meeting...</h2>
//           <p>Please wait while we connect you to the meeting</p>
//         </div>
//       ) : (
//         <div style={{ padding: "20px", textAlign: "center" }}>
//           <h1>Zoom Meeting</h1>
//           <button
//             onClick={getSignature}
//             disabled={isLoading}
//             style={{
//               padding: "10px 20px",
//               fontSize: "16px",
//               backgroundColor: "#0E71EB",
//               color: "white",
//               border: "none",
//               borderRadius: "4px",
//               cursor: "pointer",
//             }}
//           >
//             Join Meeting
//           </button>
//           {error && (
//             <div
//               style={{
//                 color: "red",
//                 margin: "15px 0",
//                 padding: "10px",
//                 backgroundColor: "#FFEEEE",
//                 borderRadius: "4px",
//               }}
//             >
//               <strong>Error:</strong> {error}
//             </div>
//           )}
//           <div style={{ marginTop: "20px" }}>
//             <h3>Meeting Details:</h3>
//             <p>Meeting ID: {meetingId || "Not provided"}</p>
//             <p>Password is {meetingPassword ? "provided" : "not provided"}</p>
//             <p>SDK Key is {sdkKey ? "provided" : "not provided"}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Zoom;

// -------------------------------------------------------------
